const roles = {
    page_title: '角色',
    title: '角色',
    subtitle: 'RBAC 是一種訪問控制方法，它使用角色來決定用戶可以做什麼事情，包括授予用戶訪問特定資源的權限。',
    create: '建立角色',
    role_name: '角色名稱',
    role_type: '角色類型',
    show_role_type_button_text: '顯示更多選項',
    hide_role_type_button_text: '隱藏更多選項',
    type_user: '使用者角色',
    type_machine_to_machine: '機器對機器應用角色',
    role_description: '描述',
    role_name_placeholder: '輸入你的角色名稱',
    role_description_placeholder: '輸入你的角色描述',
    col_roles: '角色',
    col_type: '類型',
    col_description: '描述',
    col_assigned_entities: '已分配',
    user_counts: '{{count}} 個使用者',
    application_counts: '{{count}} 個應用程式',
    user_count: '{{count}} 個使用者',
    application_count: '{{count}} 個應用程式',
    assign_permissions: '分配權限',
    create_role_title: '建立角色',
    create_role_description: '為你的應用程式建立和管理角色。角色包含權限集合，並可以分配給使用者。',
    create_role_button: '建立角色',
    role_created: '角色 {{name}} 已成功建立。',
    search: '按角色名稱、描述或 ID 搜尋',
    placeholder_title: '角色',
    placeholder_description: '角色是可以分配給使用者的權限分組。在建立角色之前，請確保先新增權限。',
};
export default Object.freeze(roles);
